import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../components/GlobalContext';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {data:[], sending: false, headerTitle: "Enter Login Details", alertMessage: "", passwordText:"",usernameText:""};
        this.history = props.history;
    }
    isLoginComponentMounted = false;
    componentDidMount() {
        if (this.isLoginComponentMounted) {
            this.populateData();
        }
    }

    async doLogin() {
        if (this.state.usernameText == "" || this.state.passwordText == "") {
            this.setState({ alertMessage: "Enter username and password" });
            return;
        }

        const response = await fetch(`api/Tote/GetLoginDetails?staffName=${this.state.usernameText}&password=${this.state.passwordText}`);
        
        const data = await response.json();
        if (data && data.length == 1) {
            MyGlobal.login(data[0]);
            this.history.push('warehouse');
        } else {
            this.setState({ alertMessage: "Incorrect username or password" });
        }
    }

    renderDropdown(data) {
        return (<select
            className="form-select form-control"
            name="selUsername"
            aria-label=".form-select-lg example"
            onChange={(e) => {
                this.setState({ usernameText: e.target.value });
            }}
            >
            {data.map(row =>
                <option key={row.Staff_Name} value={row.Staff_Name}>{row.Staff_Name}</option>
            )}
        </select>)
    }

    render() {

        if (MyGlobal.isAuthed()) {
            this.isLoginComponentMounted = false;
            return <Redirect to="warehouse" />;
        }
        else {

            this.isLoginComponentMounted = true;

            let contents = this.state.loading
                ? <p><em>Loading...</em></p>
                : this.renderDropdown(this.state.data);

            let alertMessage = this.state.alertMessage;
            alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
            return (

                <div className="">
                    {alertMessage}
                    <MyHeading>{this.state.headerTitle}</MyHeading>

                    <div className="form-group">
                        <label htmlFor="selUsername">Username</label>
                        {contents}
                    </div>

                    <div className="form-group">
                        <label htmlFor="txtPasword">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            name="txtPasword"
                            id="txtPasword"
                            value={this.state.passwordText}
                            onChange={(e) => {
                                this.setState({ passwordText: e.target.value });
                            }}
                            readOnly={this.state.sending}
                        />
                    </div>

                    <div className="container">
                        <div className="row form-group">
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.doLogin(); }}>Login</button>
                        </div>
                    </div>
                </div>

            );
        }
    }

    async populateData() {
        //   const token = await authService.getAccessToken();
        let url = `api/Tote/GetLoginNames`;
        const response = await fetch(url, {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({
            data: data
        });
    }
}
